import styled, { keyframes, css } from 'styled-components';
const OFF_SCREEN = '2000px';
const BOUNCE_IN = '-30px';
const BOUNCE_OUT = '10px';
const bounceInRight = keyframes(["0%{opacity:0;transform:translateX(", ");}60%{opacity:1;transform:translateX(", ");}80%{transform:translateX(", ");}100%{transform:translateX(0);}"], OFF_SCREEN, BOUNCE_IN, BOUNCE_OUT);
const bounceOutRight = keyframes(["0%{transform:translateX(0);}20%{transform:translateX(", ");}40%{opacity:1;transform:translateX(", ");}100%{opacity:0;transform:translateX(", ");}"], BOUNCE_OUT, BOUNCE_IN, OFF_SCREEN);
const bounceInRightAnimation = css(["animation:", " 2s;"], bounceInRight);
const bounceOutRightAnimation = css(["animation:", " 2s;"], bounceOutRight);
const BounceRightBox = styled.div.withConfig({
  displayName: "BounceRightBox",
  componentId: "h8h02i-0"
})(["will-change:transform,opacity;", ";"], ({
  $show
}) => $show ? bounceInRightAnimation : bounceOutRightAnimation);
export { BounceRightBox };